import Authentication from './Authentication';

const NotAuthenticated = () => {
    return <Authentication />;
};

export default NotAuthenticated;
